// extracted by mini-css-extract-plugin
export default {"cta":"DownloadReceiptPdf_cta__l2WLB","hidden-trigger":"DownloadReceiptPdf_hidden-trigger__JCQXK"};